import { GzPolicyUiSettingsGridItemFormWebComponent } from '../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/form';
import { html, TemplateResult } from 'lit';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { customElement, query } from 'lit/decorators.js';
import { GzFormFieldWebComponent } from '../../../../../../../../../../ui/gzForm/formField';
import { GzInputWebComponent } from '../../../../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { FormGroup } from '../../../../../../../../../../ui/gzForm/formGroup/form-group';
import { WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_SCAN_TARGET_ITEM } from '../../../../../../../../../../webcomponents.constants';
import { RequiredValidator } from '../../../../../../../../../../ui/gzForm/validators/required.validator';
import { CustomizableValidator } from '../../../../../../../../../../ui/gzForm/validators/customizable.validator';
import { ModuleId, SectionId } from '@nirvana/shared/dtos/types/policies/common';
import { FontSizes } from '../../../../../../../../../../types/common/types';
import { getSupportLinkForPlatform } from '../../../../../../../utils/links';
import { universalAbsolutePath } from '../../../../../../../../../common/policyPanel/uiSettings/utils/validators/path.validators';
import { MaxLengthValidator } from '../../../../../../../../../../ui/gzForm/validators/max-length.validator';
import { MAX_TASK_PATH_LENGTH } from '../../../../../../../utils/uiSettings/antimalware/antimalware.values';

@customElement(WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_SCAN_TARGET_ITEM)
export class GzAntimalwareOnDemandScanTargetItemFormWebComponent extends GzPolicyUiSettingsGridItemFormWebComponent {
  @query('#path')
  path: GzFormFieldWebComponent<GzInputWebComponent, string>;

  public setError(error: string) {
    this.path.setError(error);
  }

  renderFormFields(): TemplateResult {
    return html`
      <div class="policy-grid-item-form--field input--w25">
        <gz-form-field id="path">
          <gz-input
            gz-form-input
            label="${translateFn('Files and folders to scan')}"
            placeholder="${translateFn('Enter the path')}"
          ></gz-input>
          <gz-link
            fontSize="${FontSizes.PARAGRAPH_12}"
            href="${getSupportLinkForPlatform(
              { moduleId: ModuleId.ANTIMALWARE, sectionId: SectionId.ANTIMALWARE_ON_DEMAND },
              ['suggestionList']
            )}"
            >${translateFn('View list of suggestions')}</gz-link
          >
        </gz-form-field>
      </div>
    `;
  }

  focusFirstInput(): void {
    this.path.Input.inputFocus();
  }

  createFormGroup(): void {
    this.path.Validators = [
      RequiredValidator(translateFn('Required field')),
      MaxLengthValidator(
        MAX_TASK_PATH_LENGTH,
        translateFn('The path must not exceed {maxLength} characters.', {
          maxLength: MAX_TASK_PATH_LENGTH,
        })
      ),
      CustomizableValidator((val: string) => universalAbsolutePath(val, ['All Local Drives'])),
    ];

    this.formGroup = new FormGroup({
      path: this.path,
    });
  }

  resetForm(): void {
    this.path.value = '';
    this.path.resetField();
  }

  reset() {
    this.resetForm();
  }

  resetOnAdd() {
    this.resetForm();
  }
}
